/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import $ from 'jquery'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import USER_REPORT from '../BaseComponent/USERREPORT'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Sort from '../Pagination/Sort'
import HeaderGrid from '../Pagination/HeaderGrid'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import FromToPicker from '../BaseComponent/FromToPicker'
import SearchableCombo from '../BaseComponent/searchableCombo'
import Select from 'react-select'
import {productShop} from '../../lib/path'

class DriverShortage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      DriversCount: 0,
      modalActivate: false,
      modalBlock: false,
      modalReset: false,
      modalChangeCar: false,
      cars: [],
      modalDelete: false,
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'title',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شناسه رساننده',
          value: 'driverId',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'رساننده',
          value: 'driverId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'حداقل کسری',
          value: 'leastShortage',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'جزییات',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      report: [],
      editModal: false,
      receiveTimeMax: '',
      receiveTimeMin: '',
      FinalreceiveTimeMin: '',
      FinalreceiveTimeMax: '',
      driverId: '',
      drivers: [],
      printInfo: [],
      detailsDriver: [],
      tablePageNumber: 1
    }
  }

  getDrivers = () => {
    return http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }
          this.setState({
            drivers: response.data.object
          })
          return response
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.sortBy = this.state.sortBy
    let {receiveTimeMax, receiveTimeMin} = this.state
    filter.export = true
    let driverId = this.state.driverId === '' || this.state.driverId === null ? '' : this.state.driverId.personId

    if (receiveTimeMin !== '') {
      filter.planDateMin = receiveTimeMin
    }
    if (receiveTimeMax !== '') {
      filter.planDateMax = receiveTimeMax
    }
    if (driverId !== '') {
      filter.driverId = driverId
    }
    return filter
  }
  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`report/dispatch/driver/shortage/master`, {
        params: filter
      })
      .then((response) => {
        this.setState({
          FinalreceiveTimeMin: this.state.receiveTimeMin,
          FinalreceiveTimeMax: this.state.receiveTimeMax
        })
        if (response.data.error == null) {
          if (!exportStatus) {
            this.setState({
              tablePageNumber: this.state.pageNumber,
              tablePageSize: this.state.pageSize,
              report: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          message.error(response.data.description)
          this.setState({
            loading: false
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    // if (prevState.pageNumber !== this.state.pageNumber) {
    //     this.showDetail(this.state.driverId, this.state.selectedDriver)
    // }
  }
  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
    this.getDrivers()
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  filter() {
    this.setState(
      {
        pageNumber: 1
      },
      () => {
        this.getReport(false)
      }
    )
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`report/dispatch/driver/shortage/master`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState(
            {
              excelReport: response.data.object.result
            },
            () => {
              this.state.excelReport.forEach((item) => {
                item.receiveTime = jMoment(item.receiveTime).format('jYYYY/jMM/jDD HH:mm')
              })
              this._export.save(this.state.excelReport)
            }
          )
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  handleChangeFrom = (receiveTimeMin) => {
    this.setState({
      receiveTimeMin
    })
  }

  handleChangeTo = (receiveTimeMax) => {
    this.setState({
      receiveTimeMax
    })
  }

  getPrintInfo = () => {
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  getPageSize = (pageSize) => {
    this.setState({
      pageSize
    })
  }
  getPageNumber = (pageNumber) => {
    this.setState(
      {
        pageNumber
      },
      () => {
        this.showDetail(this.state.driverId, this.state.selectedDriver)
      }
    )
  }

  showDetail = (driverId, driverName) => {
    let {FinalreceiveTimeMax, FinalreceiveTimeMin} = this.state
    this.setState({
      loading: true,
      selectedDriver: driverName,
      driverId
    })
    http
      .get(
        `/report/dispatch/driver/shortage/detail?driverId=${driverId}&planDateMin=${FinalreceiveTimeMin}&planDateMax=${FinalreceiveTimeMax}`,
        {
          params: {
            export: false,
            pageSize: 10,
            pageNumber: this.state.pageNumber
          }
        }
      )
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            loading: false
          })
          this.setState(
            {
              detailModal: true
            },
            () => {
              this.setState({
                detailsDriver: res.data.object.result,
                countAll: res.data.object.countAll,
                tablePageNumber: this.state.pageNumber
              })
            }
          )
        } else {
          this.setState({
            loading: false
          })
        }
      })
      .catch((err) => {
        this.setState({
          loading: false
        })
      })
  }
  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state

    let printCol = ['ردیف', 'موبایل', 'متن پیام', 'زمان ارسال پیام']
    return (
      <div className="rtl printA4Page">
        {!this.state.detailModal && <Loader show={loading} />}

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش رساننده های آماده اعزام"
              headerColSpan={4}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={1}
              rightColSpan={1}
              centerColSpan={2}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.mobile}</td>
                  <td>{item.contents}</td>
                  <td>{jMoment(item.receiveTime).format('jYYYY/jMM/jDD HH:mm')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش رساننده های آماده اعزام.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'mobile'}
                field={'mobile'}
                title={'موبایل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'contents'}
                field={'contents'}
                title={'متن پیام'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'receiveTime'}
                field={'receiveTime'}
                title={'زمان ارسال پیام'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>توزیع</li>
            <li>گزارش رساننده های آماده اعزام</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                {/* <button className={'printButton'} onClick={this.exportExcel}>
                                    <i className='fas fa-file-excel'></i>
                                </button>
                                <button className='printButton' onClick={this.exportPrint}>
                                    <i className='fas fa-print'></i>
                                </button> */}
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFrom}
                  onChangeToDate={this.handleChangeTo}
                  fromLabel="زمان از"
                  toLabel="زمان تا"
                  defaulValue={true}
                  fromId="fromReg"
                  toId="toReg"
                />
                <div className="formComponent">
                  <label>رساننده</label>
                  <Select
                    value={this.state.driverId}
                    onChange={this.getValueDriver}
                    options={this.state.drivers}
                    isClearable={true}
                    placeholder={''}
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            {this.state.report.length > 0 && (
              <div className="showBaseTable">
                <table className="baseTable">
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  <tbody>
                    {this.state.report.map((item, index) => (
                      <tr key={index}>
                        <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                        <td>{item.driverId}</td>
                        <td>{item.fullName}</td>
                        <td>{item.leastShortage}</td>
                        <td>
                          {item.leastShortage !== null && (
                            <button onClick={() => this.showDetail(item.driverId, item.fullName)}>
                              <img src={require('../../image/eye.svg')} alt="" />
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
        <Modal
          isOpen={this.state.detailModal}
          toggle={() => this.setState({detailModal: false, pageNumber: 1})}
          size="lg"
        >
          <ModalHeader toggle={() => this.setState({detailModal: false, pageNumber: 1})}>
            <span>جزییات اقلام رساننده ‌:‌ </span>
            <span className="mx-1">{this.state.selectedDriver}</span>
          </ModalHeader>
          <ModalBody>
            <Loader show={this.state.loading} />

            {this.state.detailsDriver.length > 0 && (
              <table className="table mb-0 table-bordered table-striped">
                <tr className="bg-light">
                  <td>ردیف</td>
                  <td>تامین کننده</td>
                  <td>کد محصول</td>
                  <td>بارکد</td>
                  <td>نام محصول</td>
                  <td>مقدار مورد نیاز</td>
                  <td>واحد شمارش</td>
                </tr>
                {this.state.detailsDriver.map((item, index) => (
                  <tr key={index}>
                    <td>{(this.state.tablePageNumber - 1) * 10 + index + 1}</td>
                    <td>{item.providerName}</td>
                    <td>{item.productId}</td>
                    <td>{item.barCode}</td>
                    <td>
                      <a
                        style={{color: 'blue'}}
                        target="_blank"
                        className="btn-link"
                        href={productShop({articleId: item.productId})}
                      >
                        {item.productTitle}
                      </a>
                    </td>
                    <td>{item.neededQuantity}</td>
                    <td>{item.unitName}</td>
                  </tr>
                ))}
              </table>
            )}
            <div className="paginationWrapp">
              <Pageing
                defaultCurrent={1}
                getPage={this.getPageNumber}
                pageSize={10}
                currentPage={this.state.pageNumber}
                total={this.state.countAll}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({detailModal: false, pageNumber: 1})}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default DriverShortage
